import { batchOperateStatus } from '@/api/ggd';
import { Dialog, Toast } from 'antd-mobile';

// 处理批量开合闸操作
export const handleBatchOperate = async (deviceIds: number[], status: number, successCallback?: () => void) => {
  try {
    await batchOperateStatus({ deviceIds, status })
      .onError(err => {
        const { status, errorMessage } = err?.cause;
        if (status === 60000) {
          Toast.show({
            content: errorMessage,
          });
          throw err;
        } else {
          Dialog.clear();
          Dialog.alert({
            content: errorMessage || '开合闸命令下发失败',
            closeOnMaskClick: true,
          });
        }
      })
      .then(res => {
        Toast.show({
          content: '下发成功',
        });
      });
    successCallback && successCallback();
  } catch (error) {
    console.error('操作失败:', error);
  }
};
